import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["input", "item"]
  static values = {
    minLength: Number
  }

  connect() {
    this.update()
  }

  update() {
    const password = this.hasInputTarget ? this.inputTarget.value : ""
    const states = {
      length: password.length >= this.minLengthValue,
      lowercase: /[a-z]/.test(password),
      uppercase: /[A-Z]/.test(password),
      number: /\d/.test(password)
    }

    this.itemTargets.forEach((item) => {
      const met = Boolean(states[item.dataset.requirement])
      item.dataset.met = met ? "true" : "false"
    })
  }
}
